module.exports = __webpack_public_path__ + "static/media/borderlands-3-logo.088550b3.png";